module.exports = __webpack_public_path__ + "img/3-5.ae4b9f66.svg";